<template>
  <div class="research-filter-bar">
    <div class="research-filter-bar-left">
      <button
        class="research-filter-bar-left-button primary"
        @click="onExportClick"
      >
        导出数据
      </button>
    </div>
    <div class="research-filter-bar-right">
      <div class="filter-item">
        <span class="filter-label">用户创建时间</span>
        <el-date-picker
          class="filter-date-picker" 
          v-model="tempDateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="onDateChange"
        >
        </el-date-picker>
      </div>
      
      <div class="filter-item">
        <span class="filter-label">量表</span>
        <el-select
          collapse-tags
          v-model="tempType"
          placeholder="请选择量表"
          multiple
          clearable
          class="scale-selector"
          @change="onTypeChange"
        >
          <el-option
            v-for="item in assessmentList"
            :key="item.id"
            :label="item.assessmentName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      
      <div class="filter-item">
        <span class="filter-label">睡眠报告</span>
        <el-select
          v-model="tempSleepReportShow"
          style="width: 70px"
          @change="onSleepReportShowChange"
        >
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </div>
      
      <div class="filter-item">
        <span class="filter-label">睡眠初筛报告</span>
        <el-select
          v-model="tempRingReportShow"
          style="width: 70px"
          @change="onRingReportShowChange"
        >
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </div>
      
      <keyword-search
        class="research-filter-bar-right-keyword-search"
        title="姓名"
        v-model="tempKeyword"
        @onSearchClick="onSearchClick"
      ></keyword-search>
    </div>
  </div>
</template>

<script>
import KeywordSearch from "@c/operation-log/common/filter-bar/keyword-search.vue";

export default {
  components: {
    KeywordSearch,
  },

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    assessmentList: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      tempDateRange: null,
      tempType: [],
      tempSleepReportShow: 1,
      tempRingReportShow: 1,
      tempKeyword: ""
    };
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.tempType = newVal.type || [];
          this.tempSleepReportShow = newVal.sleepReportShow !== undefined ? newVal.sleepReportShow : 1;
          this.tempRingReportShow = newVal.ringReportShow !== undefined ? newVal.ringReportShow : 1;
          this.tempKeyword = newVal.keyword || "";
          
          if (newVal.startTime && newVal.endTime) {
            // 提取日期部分，去掉时分秒
            const startDate = newVal.startTime.split(' ')[0];
            const endDate = newVal.endTime.split(' ')[0];
            this.tempDateRange = [startDate, endDate];
          } else {
            this.tempDateRange = null;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    onDateChange() {
      const value = { ...this.value };
      if (this.tempDateRange && this.tempDateRange.length === 2) {
        value.startTime = this.tempDateRange[0] + ' 00:00:00';
        value.endTime = this.tempDateRange[1] + ' 23:59:59';
      } else {
        value.startTime = undefined;
        value.endTime = undefined;
      }
      this.$emit('input', value);
      // 创建时间筛选立即触发查询
      this.$emit('onFilterChange');
    },

    onTypeChange() {
      const value = { ...this.value };
      value.type = this.tempType;
      this.$emit('input', value);
      // 量表筛选立即触发查询
      this.$emit('onFilterChange');
    },

    onSleepReportShowChange() {
      const value = { ...this.value };
      value.sleepReportShow = this.tempSleepReportShow;
      this.$emit('input', value);
      // 睡眠报告筛选立即触发查询
      this.$emit('onFilterChange');
    },

    onRingReportShowChange() {
      const value = { ...this.value };
      value.ringReportShow = this.tempRingReportShow;
      this.$emit('input', value);
      // 睡眠初筛报告筛选立即触发查询
      this.$emit('onFilterChange');
    },

    onSearchClick(keyword) {
      this.tempKeyword = keyword;
      const value = { ...this.value };
      value.keyword = keyword;
      this.$emit('input', value);
      this.$emit('onSearchClick');
    },

    onExportClick() {
      this.$emit('onExportClick');
    }
  },
};
</script>

<style lang="scss" scoped>
.research-filter-bar {
  padding: rem(20) rem(0);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-width: 1200px;

  @media (max-width: 1440px) {
    min-width: auto;
    max-width: 100%;
  }

  &-left {
    display: flex;
    flex-shrink: 0;

    &-button {
      font-size: rem(14);
      border-radius: rem(4);
      width: rem(88);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      cursor: pointer;
      
      &.primary {
        color: white;
        background-color: #325fac;
        
        &:hover {
          background-color: rgb(91, 127, 189);
        }
        
        &:active {
          background-color: rgb(45, 86, 155);
        }
      }
    }
  }

  &-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-shrink: 0;

    @media (max-width: 1440px) {
      flex-wrap: wrap;
      gap: 8px;
    }

    .filter-item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      flex-shrink: 0;
      
      @media (max-width: 1440px) {
        margin-right: 0;
        margin-bottom: 8px;
      }
      
      .filter-label {
        font-size: rem(14);
        color: #333;
        white-space: nowrap;
        margin-right: 6px;
      }
      
      .filter-date-picker {
        width: 230px;
        
        @media (max-width: 1440px) {
          width: 200px;
        }
      }
      
      .scale-selector {
        width: 200px;
        
        @media (max-width: 1440px) {
          width: 160px;
        }
      }
    }

    &-keyword-search {
      margin-left: 5px;
      
      @media (max-width: 1440px) {
        margin-left: 0;
        margin-bottom: 8px;
      }
    }
  }
}

:deep(.el-select) {
  .el-input__inner {
    font-size: rem(14);
  }
}

:deep(.el-date-editor) {
  .el-input__inner {
    font-size: rem(14);
  }
}

// 针对1440px分辨率调整姓名搜索框宽度
@media (max-width: 1440px) {
  .research-filter-bar {
    :deep(.device-search) {
      .device-search-middle {
        width: rem(120);
      }
      
      .device-search-button {
        width: rem(45);
      }
    }
  }
}
</style>